const types = {
    COMMUNITY_LOADING: "COMMUNITY_LOADING",
    COMMUNITY_LOADED: "COMMUNITY_LOADED",
    SET_COMMUNITY_ERROR: "SET_COMMUNITY_ERROR",
    CLEAN_UP_COMMUNITY: "CLEAN_UP_COMMUNITY",

    CREATE_COMMUNITY_START: "CREATE_COMMUNITY_START",
    CREATE_COMMUNITY_SUCCESS: "CREATE_COMMUNITY_SUCCESS",
    CREATE_COMMUNITY_ERROR: "CREATE_COMMUNITY_ERROR",

    FETCH_COMMUNITY_START: "FETCH_COMMUNITY_START",
    FETCH_COMMUNITY_SUCCESS: "FETCH_COMMUNITY_SUCCESS",
    FETCH_COMMUNITY_ERROR: "FETCH_COMMUNITY_ERROR",

    DELETE_COMMUNITY_START: "DELETE_COMMUNITY_START",
    DELETE_COMMUNITY_SUCCESS: "DELETE_COMMUNITY_SUCCESS",
    DELETE_COMMUNITY_ERROR: "DELETE_COMMUNITY_ERROR",

    MOVE_COMMUNITY_START: "MOVE_COMMUNITY_START",
    MOVE_COMMUNITY_SUCCESS: "MOVE_COMMUNITY_SUCCESS",
    MOVE_COMMUNITY_ERROR: "MOVE_COMMUNITY_ERROR",

    DUPLICATE_COMMUNITY_START: "DUPLICATE_COMMUNITY_START",
    DUPLICATE_COMMUNITY_SUCCESS: "DUPLICATE_COMMUNITY_SUCCESS",
    DUPLICATE_COMMUNITY_ERROR: "DUPLICATE_COMMUNITY_ERROR",

    BATCH_DELETE_COMMUNITY_START: "BATCH_DELETE_COMMUNITY_START",
    BATCH_DELETE_COMMUNITY_SUCCESS: "BATCH_DELETE_COMMUNITY_SUCCESS",
    BATCH_DELETE_COMMUNITY_ERROR: "BATCH_DELETE_COMMUNITY_ERROR",

    SAVE_COMM_ECM_INPUT_MAP_START: "SAVE_COMM_ECM_INPUT_MAP_START",
    SAVE_COMM_ECM_INPUT_MAP_SUCCESS: "SAVE_COMM_ECM_INPUT_MAP_SUCCESS",
    SAVE_COMM_ECM_INPUT_MAP_ERROR: "SAVE_COMM_ECM_INPUT_MAP_ERROR",

    SAVE_COMMUNITY_START: "SAVE_COMMUNITY_START",
    SAVE_COMMUNITY_SUCCESS: "SAVE_COMMUNITY_SUCCESS",
    
    ADD_MODEL_TO_COMMUNITY: "ADD_MODEL_TO_COMMUNITY",
    REMOVE_MODEL_FROM_COMMUNITY: "REMOVE_MODEL_FROM_COMMUNITY",

    UPDATE_COMMUNITY_DETAILS: "UPDATE_COMMUNITY_DETAILS",
    UPDATE_COMMUNITY_SETTINGS: "UPDATE_COMMUNITY_SETTINGS",
    UPDATE_MODEL_DIR_COPIES: "UPDATE_MODEL_DIR_COPIES",
    SAVE_COMMUNTIY_DATA: "SAVE_COMMUNTIY_DATA",

    // Synchronous actions
    ADD_UPGRADE_TO_COMMUNITY: "ADD_UPGRADE_TO_COMMUNITY",
    REMOVE_UPGRADE_FROM_COMMUNITY: "REMOVE_UPGRADE_FROM_COMMUNITY",
    TOGGLE_UPGRADE_IN_COMMUNITY: "TOGGLE_UPGRADE_IN_COMMUNITY",
    UPDATE_COMM_ECM_INPUT_MAP_UPGRADE: "UPDATE_COMM_ECM_INPUT_MAP_UPGRADE",
    UPDATE_COMM_DETAILS: "UPDATE_COMM_DETAILS",
    UPDATE_COMM_FUEL_COSTS: "UPDATE_COMM_FUEL_COSTS",
    UPDATE_RUN_RESULTS: "UPDATE_RUN_RESULTS",

    MERGE_COMMUNITY_ECM_VALIDATION_RESULTS: "MERGE_COMMUNITY_ECM_VALIDATION_RESULTS",
};

export default types;
